export const SITE_ORIGIN = 'https://blissful-play.com';

export const siteOrigin = () => (typeof window !== 'undefined' ? window.location.origin : SITE_ORIGIN);

const absolute = (origin, url) => (url && url.startsWith('/') ? origin + url : url);

// schema.org Product + Offer for one product
export const productNode = (p, origin = siteOrigin()) => ({
  '@type': 'Product',
  name: p.name,
  image: absolute(origin, p.image_url),
  url: `${origin}/product/${p.product_id}`,
  brand: { '@type': 'Brand', name: 'Blissful Play' },
  offers: {
    '@type': 'Offer',
    price: Number(p.price).toFixed(2),
    priceCurrency: 'EUR',
    availability:
      typeof p.stock === 'number' && p.stock <= 0 ? 'https://schema.org/OutOfStock' : 'https://schema.org/InStock',
    url: `${origin}/product/${p.product_id}`,
  },
});

export const JsonLd = ({ data }) => (
  <script
    type="application/ld+json"
    // JSON.stringify output with "<" escaped so it can't close the script tag
    dangerouslySetInnerHTML={{ __html: JSON.stringify(data).replace(/</g, '\\u003c') }}
  />
);
